import React, { ChangeEventHandler } from "react";

type RadioButtonContextValue = {
  id: string;
  name: string;
  buttonId: string;
  checkedId: string;
  onRadioClick: ChangeEventHandler<HTMLInputElement>;
};

const RadioButtonContext = React.createContext<RadioButtonContextValue>({
  id: "",
  name: "",
  buttonId: "",
  checkedId: "",
  onRadioClick: () => undefined,
});

const RadioButtonProvider = RadioButtonContext.Provider;
const RadioButtonConsumer = RadioButtonContext.Consumer;

export { RadioButtonContext, RadioButtonProvider, RadioButtonConsumer };
